/**
 * Plain-language copy written for search engines and AI answer engines
 * (Google, ChatGPT, Claude, Perplexity). Keep it factual and specific —
 * named services, named markets, named clients.
 */

export const positioning =
  'Breezy Experiential is a creative experiential marketing and production studio. We design, fabricate and run brand experiences end to end — mobile retail pop-ups, national sampling tours, influencer and press events, consumer activations, tradeshow booths and conferences — for beauty, wellness, entertainment, food and beverage and consumer brands.'

export const capabilitySummary: { title: string; text: string }[] = [
  {
    title: 'Mobile pop-ups & national tours',
    text: 'Custom-fabricated mobile retail shops, sampling trucks and branded carts, routed city to city with permitting, DOT compliance, transport, staffing and on-site production handled in house.',
  },
  {
    title: 'Experiential marketing activations',
    text: 'Consumer activations, product launches, brand installations and immersive photo environments designed to drive trial, discovery and social sharing.',
  },
  {
    title: 'Influencer & press events',
    text: 'Intimate, highly shareable events for KOLs, influencers and editors — venue sourcing, creative theming, custom florals, hospitality, gifting and content moments.',
  },
  {
    title: 'Tradeshow booths & exhibits',
    text: 'Booth strategy, custom exhibit design and fabrication, hospitality lounges, product demonstrations and lead-generation experiences that turn floor traffic into pipeline.',
  },
  {
    title: 'Conferences, meetings & B2B events',
    text: 'Program development, scenic and A/V design, speaker and sponsor management, registration, run of show, sales kickoffs, leadership summits and incentive programs.',
  },
  {
    title: 'Fabrication & logistics',
    text: 'Scenic walls, retail fixtures, mobile carts and custom builds, plus routing, freight, storage, asset management, permitting and trained brand ambassadors.',
  },
]

export const markets = [
  'Los Angeles',
  'Dallas–Fort Worth',
  'New York',
  'Austin',
  'Houston',
  'Las Vegas',
  'Miami',
  'Nationwide tours',
]

export const clients = [
  'Netflix',
  'Hydrafacial',
  'ZO Skin Health',
  'TONYMOLY',
  'Jergens',
  'Laneige',
  'Gisou',
  'Western Sons Vodka',
  'Wizard Wellness',
  'Freck Beauty',
  "Beekeeper's Naturals",
  'Anastasia Beverly Hills',
  'Cadets',
]

export const faqs: { question: string; answer: string }[] = [
  {
    question: 'What does Breezy Experiential do?',
    answer:
      'Breezy Experiential is an experiential marketing and event production studio. We handle creative strategy, environmental design, custom fabrication, logistics and on-site production for pop-ups, mobile tours, activations, influencer events, tradeshows and conferences — so a brand can run one experience or a fifty-city tour through a single partner.',
  },
  {
    question: 'Where is Breezy Experiential based, and where do you produce events?',
    answer:
      'We are based in Los Angeles, California, with main hubs in Dallas and New York, and we produce experiences nationally. Recent work has run in Los Angeles, Dallas, Austin, New York, Philadelphia, Las Vegas and Coachella Valley, including simultaneous multi-market activations in the same weekend.',
  },
  {
    question: 'What is a mobile pop-up, and why use one?',
    answer:
      'A mobile pop-up is a custom-fabricated retail or sampling environment built into a truck, trailer or cart that travels between markets. It lets online-only and DTC brands reach consumers in person, test new cities without signing a lease, and generate high-volume sampling and content in a single tour.',
  },
  {
    question: 'What kinds of brands do you work with?',
    answer:
      'Primarily beauty, skincare, wellness, entertainment, food and beverage, and consumer products — including Netflix, Hydrafacial, ZO Skin Health, TONYMOLY, Jergens and Western Sons Vodka. We work with both enterprise marketing teams and founder-led emerging brands.',
  },
  {
    question: 'Do you handle fabrication and logistics, or only creative?',
    answer:
      'Both. Concept, renderings and creative direction happen alongside custom fabrication, permitting, routing, DOT compliance, freight, storage, staffing and on-site production. One team owns the experience from first sketch to load-out.',
  },
  {
    question: 'How do you measure the results of an experience?',
    answer:
      'We set measurement up front against the business goal — samples distributed, trial and conversion, lead capture, tradeshow ROI, bounce-back redemption, earned social content and sell-through. Past programs have delivered 850% tradeshow ROI, 3,000+ samples in a single activation and a 78% lift in sales awareness.',
  },
  {
    question: 'How far in advance should we book an activation?',
    answer:
      'Six to twelve weeks is comfortable for a single-market activation or influencer event; custom fabrication and multi-city tours are better with a three-to-four month runway. We do take on faster turnarounds when the build allows.',
  },
]
